module.exports = __webpack_public_path__ + "img/avatar7.4ca50cc8.png";